import Component, { mixins } from 'vue-class-component'
import { Prop, Ref } from 'vue-property-decorator'

import WithRender from './InscriptionOffreCoursPanel.html'

import { 
  MPanel
} from '@ulaval/modul-components'

import InscriptionLieuExamenForm from '@/modules/inscription-lieu-examen/form/InscriptionLieuExamenForm'

import IFormInscriptionOffreCours from './IFormInscriptionOffreCours.model'
import IFormInscriptionLieuExamen from './IFormInscriptionLieuExamen.model'

const REF_INSCRIPTION_LIEU_EXAMEN_FORM: string = 'inscription-lieu-examen-form'

@WithRender
@Component({
  components: {
    InscriptionLieuExamenForm,
    MPanel
  }
})
export default class InscriptionOffreCoursPanel extends mixins() {
  private readonly REF_INSCRIPTION_LIEU_EXAMEN_FORM: string = REF_INSCRIPTION_LIEU_EXAMEN_FORM

  @Ref(REF_INSCRIPTION_LIEU_EXAMEN_FORM)
  public inscriptionLieuExamenFormComponents!: Array<InscriptionLieuExamenForm> | InscriptionLieuExamenForm | null

  @Prop({ required: true })
  private inscriptionOffreCours!: IFormInscriptionOffreCours

  private get inscriptionLieuExamenList(): Array<IFormInscriptionLieuExamen> {
    if (this.inscriptionOffreCours.inscriptionsLieuExamen) {
      return this.inscriptionOffreCours.inscriptionsLieuExamen
    } else if (this.inscriptionOffreCours.examen) {
      return [this.inscriptionOffreCours.examen]
    }

    return []
  }
}
